import { render, staticRenderFns } from "./BaseHistoryCard.vue?vue&type=template&id=59ddade2&scoped=true"
import script from "./BaseHistoryCard.vue?vue&type=script&lang=js"
export * from "./BaseHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./BaseHistoryCard.vue?vue&type=style&index=0&id=59ddade2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ddade2",
  null
  
)

export default component.exports